export default {
  originalReportData: null,
  reportData: null,
  isFetchingReportData: false,
  isExportingReport: false,
  aggregationDroplistValue: null,
};

